import { Adapter } from '@fmnts/core';
import { RequirementType } from '../api-model/api-enums';
import { IApiRequirement } from '../api-model/campaign.api';
import {
  LocationSelectRequirement,
  PhotoVerifyRequirement,
  QuizRequirement,
  Requirement,
} from '../model/requirement';

export class ApiRequirementAdapter
  implements Adapter<Requirement, IApiRequirement>
{
  private readonly supportedRequirementTypes = new Set([
    RequirementType.LocationSelect,
    RequirementType.PhotoVerify,
    RequirementType.Quiz,
  ]);

  adapt(item: IApiRequirement): Requirement {
    if (!this.canAdapt(item)) {
      throw Error(`Unknown requirement type: ${item.require}`);
    }

    return this._adaptByRequirementType(item);
  }

  public canAdapt(item: IApiRequirement): boolean {
    return this.supportedRequirementTypes.has(item.require as RequirementType);
  }

  private _adaptByRequirementType(
    item: IApiRequirement,
  ): PhotoVerifyRequirement | LocationSelectRequirement | QuizRequirement {
    const require = item.require as RequirementType;

    switch (require) {
      case RequirementType.Quiz:
        return {
          require,
          config: {
            quiz: `${item.config.quiz}`,
          },
        };
      case RequirementType.LocationSelect:
      case RequirementType.PhotoVerify:
        return {
          require,
          config: null,
        };
    }
  }
}
